import { MatPaginatorIntl } from '@angular/material/paginator';

const roRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length == 0 || pageSize == 0) {
        return `0 din ${length}`;
    }

    length = Math.max(length, 0);

    const startIndex = page * pageSize;

    const endIndex =
        startIndex < length
            ? Math.min(startIndex + pageSize, length)
            : startIndex + pageSize;

    return `${startIndex + 1} - ${endIndex} din ${length}`;
};

export function getRoPaginatorIntl() {
    const paginatorIntl = new MatPaginatorIntl();

    paginatorIntl.itemsPerPageLabel = 'Rezultate per pagina:';
    paginatorIntl.firstPageLabel = 'Prima pagina';
    paginatorIntl.nextPageLabel = 'Pagina urmatoare';
    paginatorIntl.previousPageLabel = 'Pagina anterioara';
    paginatorIntl.lastPageLabel = 'Ultima pagina';
    paginatorIntl.getRangeLabel = roRangeLabel;

    return paginatorIntl;
}
